import type { ReactNode } from 'react';
import { RequirementForm } from './requirement-form';

/**
 * The requirements section of a document.
 *
 * A requirement binds a subject to a SPECIFIC version, so this section needs a selected
 * version before it can offer the form.
 */
export function RequirementsSection(props: {
  documentId: string;
  audience: 'tenant' | 'customer';
  selectedVersionId: string | null;
  onChanged: () => void;
}): ReactNode {
  if (!props.selectedVersionId) {
    return (
      <p className="text-sm text-content-muted">
        A requirement binds a subject to a specific version. Publish a version, then configure a
        requirement against it.
      </p>
    );
  }
  return (
    <RequirementForm
      documentId={props.documentId}
      versionId={props.selectedVersionId}
      audience={props.audience}
      onCreated={props.onChanged}
    />
  );
}
